<template>
    <div>
        <div class="title">设计确认</div>
        <div class="part-item" v-for="(item,index) in part" :key="index">
            <span class="name">{{ item.name }}</span>
            <span class="value">{{item.value}}</span>
        </div>
        <div class="fabric-item">
            <div class="fabric-item-name">
                <div class="name">材质</div>
                <div class="value">{{current_fabric.fabric_name_cn}}</div>
            </div>
            <div class="mianliao-item-name">
                <div class="name">面料</div>
                <div class="value">
                    <span>{{current_color.color_name_cn}}</span>
                    <div class="color" :style="colorValue(current_color.color_value)"></div>
                </div>
            </div>
            <div class="total-price">￥ {{(current_fabric.fabric_price || 0) | price_format }}</div>
        </div>

        <div class="style-item-section" v-if="style_data.length">
            <div class="style-item" v-for="(v, k) in style_data" :key="'confirm-style-' + k">
                <div class="name">{{v.name}}</div>
                <div class="value" v-if="v.print_type == 1">{{(v.price_yh )|price_format}}</div>
                <div class="value" v-else-if="v.print_type == 2">{{(v.price_xh)|price_format}}</div>
                <div class="value" v-else>0</div>
            </div>
            <div class="total-price">￥ {{ style_total_price | price_format }}</div>
        </div>

        <div class="submit" @click="go2figure">{{btn_text}}</div>
    </div>
</template>

<script>
    import C from '@/utils/constant'
    import {mapState} from 'vuex'
    export default {
        name: "Confirm",
        data() {
            return {
            }
        },
        computed: {
            ...mapState({
                category: (state) => state.mtm.picked_category,
                original_part: (state) => state.mtm.picked_category.hasOwnProperty('part') ? state.mtm.picked_category.part : Array.of(),
                selected_part: (state) => state.mtm.form_data.part_list,
                current_fabric(state) {
                    return state.mtm.form_data.fabric_list.material
                },
                // 当前选中布料颜色
                current_color(state) {
                    return {...state.mtm.form_data.fabric_list.color, fabric_key: this.current_fabric?.fabric_key}
                },
                style_data: (state) => state.mtm.form_data.customize_data,
                form_data: (state) => state.mtm.form_data,
            }),
            style_total_price() {
                let total = 0;
                this.style_data.forEach((item) => {
                    let temp = 0;
                    if(item.print_type == 1) temp = item.price_yh
                    if(item.print_type == 2) temp = item.price_xh
                    total += parseFloat(temp)
                })

                return total
            },
            part() {
                let result = []
                for(let key in this.selected_part) {
                    let part = this.original_part.find((v) => {
                        return v.category_key === key
                    })
                    result.push({
                        name: part.category_name_cn,
                        value: this.selected_part[key]
                    })
                }
                return result
            },
            figure_page() {
                if(this.$route.params.is_group) {
                    return 'GroupFigure'
                } else {
                    return 'Figure'
                }
            },
            btn_text() {
                let text = '设计完成，去量体'
                if(this.form_data.mtm_type == C.MTM_TYPE_SIZE) {
                    text = '设计完成，填写尺码'
                }
                return text
            }
        },
        methods: {
            go2figure() {
                if(this.form_data.mtm_type == C.MTM_TYPE_SIZE) {
                    this.$router.push({name: 'Checkout'})
                    return
                }
                if(this.category.customize_data.length) {
                    for(let i in this.style_data)  {
                        if(!this.style_data[i].print_type) {
                            this.$Message.error(`${this.style_data[i].name}制作方式未完善`)
                            return
                        }
                        if(this.style_data[i].type == 2 && !this.style_data[i].image_value) {
                            this.$Message.error(`${this.style_data[i].name}定制数据未完善`)
                            return
                        }
                        if(this.style_data[i].type == 1 && (!this.style_data[i].text_value || !this.style_data[i].text_font  || !this.style_data[i].text_color )) {
                            this.$Message.error(`${this.style_data[i].name}定制数据未完善`)
                            return
                        }
                    }
                }
                this.$router.push({
                    name: this.figure_page
                })
            },
            colorValue(color_value) {
                if(!color_value) return "";
                if (color_value.indexOf("http") >= 0) {
                    return `background-image:url(${color_value + '?x-oss-process=image/resize,w_100,h_100,m_pad,color_FFFFFF'});background-size:cover`;
                }
                return "background:" + color_value;
            }
        }
    }
</script>

<style scoped lang="scss">

    .title {
        height: 44px;
        line-height: 44px;
        font-size: 15px;
        font-weight: bold;
        color: #000000;
        text-align: center;
    }

    .part-item {
        margin: 0 20px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #e9e9e9;

        .name {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
        }

        .value {
            font-size: 12px;
            color: #666666;
        }
    }

    .fabric-item {
        width: 90%;
        background: #fafafa;
        border-radius: 6px;
        padding: 10px;
        margin: 10px auto;

        .fabric-item-name,
        .mianliao-item-name {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            .name {
                font-size: 13px;
                color: #333333;
                font-weight: bold;
            }

            .value {
                display: flex;
                justify-content: flex-end;
                width: 167px;
                font-size: 12px;
                color: #666666;

                .color {
                    width: 20px;
                    height: 20px;
                    background: rgba(0, 0, 0, 0);
                    opacity: 1;
                    border-radius: 2px;
                    margin-left: 10px;
                }
            }
        }
    }


    .style-item-section {
        width: 230px;
        background: #fafafa;
        border-radius: 6px;
        padding: 10px;
        margin: 10px auto;

        .style-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            .name {
                font-size: 13px;
                color: #333333;
                font-weight: bold;
            }

            .value {
                display: flex;
                justify-content: flex-end;
                width: 167px;
                font-size: 12px;
                color: #666666;

            }
        }
    }

    .total-price {
        height: 40px;
        line-height: 40px;
        text-align: right;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #0f114a;
        border-top: 1px solid #dddddd;
        margin-top: 10px;
    }

    .submit {
        cursor: pointer;
        width: 230px;
        height: 44px;
        line-height: 44px;
        background: #0f114a;
        border-radius: 4px;
        margin: 20px auto;
        font-size: 16px;
        font-weight: bold;
        color: #edd4ac;
        text-align: center;
    }
</style>
